export default {
  getDefaultState: () => {
    return {
      mileageCategories: [],
      mileageCategoriesFilters: {},
      mileageCategoriesCurrentPage: 1,
      mileageCategoriesLastPage: 1,
      dietCategories: [],
      dietCategoriesFilters: {},
      dietCategoriesCurrentPage: 1,
      dietCategoriesLastPage: 1,
      isCallingExpenses: false
    }
  }
}
